import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "utils",
  standalone: true,
})
export class UtilsPipe implements PipeTransform {

  transform(value: string, args: any[]): string {
    switch (args[0]) {
      case "formatTimestamp":
        return this.formatTimestamp(Number(value));
      case "nl2br":
        return this.nl2br(value);
      case "mdLinkToHtml":
        return this.mdLinkToHtml(value);
      case "promptToHtml":
        return this.promptToHtml(value);
      case "capitalize":
        return this.capitalize(value);
      case "truncate":
        return this.truncate(value, args[1]);
      default:
        return value;
    }
  }

  formatTimestamp(timestamp: number) {
    const date = new Date(timestamp);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} (UTC)`;
  }

  private capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  private truncate(str: string, length: number): string {
    if (str.length <= length) {
      return str;
    }
    return str.slice(0, length) + "...";
  }

  private nl2br(str: string): string {
    return str.replace(/\n/g, "<br />");
  }

  private mdLinkToHtml(str: string): string {
    const linkRegex = /\[([^\]]+)\]\(([^\)]+)\)/g;
    return str.replace(linkRegex, '<a href="$2" target="_blank">$1</a>');
  }

  private promptToHtml(str: string): string {
    const linkRegex = /\[([^\]]+)\]\(([^\)]+)\)/g;
    return `<div>${str.replace(linkRegex, '<a href="$2" target="_blank">$1</a>').replace(/\n/g, '<br />')}</div>`;
  }
}
